export function initMobileMenuScroll() {
    const menu = document.querySelector('.mobile-menu') as HTMLElement | null;
    if (!menu) return;

    let lastScroll = window.pageYOffset;

    const onScroll = () => {
        if (window.innerWidth >= 991) {
            menu.classList.remove('active');
            lastScroll = window.pageYOffset;
            return;
        }

        const current = window.pageYOffset;

        if (current < lastScroll) {
            // скролл вверх
            menu.classList.add('active');
        } else {
            // скролл вниз
            menu.classList.remove('active');
        }

        lastScroll = current;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
}
